(function(){
  'use strict';

  var loader = document.getElementById('auroly-page-loader');
  var hideTimer = null;

  function hideLoader(){
    if (!loader) return;
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function(){ loader.classList.add('is-hidden'); }, 40);
  }

  function showLoader(){
    if (!loader) return;
    window.clearTimeout(hideTimer);
    loader.classList.remove('is-hidden');
  }

  function isCartUrl(url){
    return /\/cart\/?$/.test(url.pathname);
  }

  function getCartDrawer(){
    return document.getElementById('cart-drawer');
  }

  function openCartDrawer(){
    var drawer = getCartDrawer();
    if (!drawer) return false;
    hideLoader();
    if (typeof drawer.show === 'function') {
      drawer.show();
      return true;
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(function(){
        var readyDrawer = getCartDrawer();
        if (readyDrawer && typeof readyDrawer.show === 'function') readyDrawer.show();
      });
      return true;
    }
    return false;
  }

  function closeHeaderPanels(){
    var header = document.getElementById('AurolyHeader');
    if (!header) return;
    header.querySelectorAll('.is-open').forEach(function(el){ el.classList.remove('is-open'); });
    header.querySelectorAll('[aria-expanded="true"]').forEach(function(el){ el.setAttribute('aria-expanded','false'); });
  }

  function updateCartCount(count){
    var header = document.getElementById('AurolyHeader');
    if (!header) return;
    var cartLinks = Array.prototype.slice.call(header.querySelectorAll('a[href]')).filter(function(link){
      try { return isCartUrl(new URL(link.href, location.href)); } catch (_) { return false; }
    });
    cartLinks.forEach(function(link){
      var badge = link.querySelector('.auroly-header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'auroly-header__cart-count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  /* Consistent white transition: visible by default in CSS, then removed quickly once the page is interactive. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideLoader, { once: true });
  } else {
    hideLoader();
  }
  window.addEventListener('pageshow', hideLoader);
  window.addEventListener('pagehide', function(){ /* keep state controlled by click navigation only */ });

  /* One delegated click listener for cart drawer, coupon actions and real page transitions. */
  document.addEventListener('click', function(e){
    var expressToggle = e.target.closest && e.target.closest('[data-auroly-express-toggle]');
    if (expressToggle) {
      e.preventDefault();
      var buyNow = expressToggle.closest('.auroly-cart-buy-now');
      var panel = buyNow && buyNow.querySelector('[data-auroly-express-panel]');
      if (!panel) return;
      var isOpen = expressToggle.getAttribute('aria-expanded') === 'true';
      expressToggle.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      return;
    }

    var checkoutButton = e.target.closest && e.target.closest('[data-auroly-checkout]');
    if (checkoutButton) {
      showLoader();
      return;
    }

    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;

    var url;
    try { url = new URL(a.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;

    if (isCartUrl(url)) {
      if (openCartDrawer()) {
        e.preventDefault();
        e.stopPropagation();
        closeHeaderPanels();
      }
      return;
    }

    if (a.hasAttribute('aria-controls') || a.closest('cart-drawer') || a.closest('product-form')) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    showLoader();
  }, true);

  document.addEventListener('cart:change', function(event){
    var cart = event.detail && event.detail.cart;
    if (!cart || typeof cart.item_count === 'undefined') return;

    updateCartCount(cart.item_count);

    /* If the last item is removed, avoid the dead-end empty cart page. */
    if (cart.item_count === 0) {
      showLoader();
      window.setTimeout(function(){
        window.location.assign('/collections/bastsaljare');
      }, 60);
    }
  });

  /* Product buy box: 48-hour Stockholm campaign and direct checkout button. */
  document.querySelectorAll('[data-aup-buybox]').forEach(function(box){
    var timer = box.querySelector('[data-aup-countdown-cycle]');
    if (timer) {
      var timeZone = 'Europe/Stockholm';
      function zoneParts(ms){
        var parts = new Intl.DateTimeFormat('sv-SE',{timeZone:timeZone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(new Date(ms));
        var out = {};
        parts.forEach(function(p){ if (p.type !== 'literal') out[p.type] = Number(p.value); });
        return out;
      }
      function stockholmLocalMidnightUtc(y,m,d){
        var target = Date.UTC(y,m-1,d,0,0,0), guess = target;
        for (var i=0;i<4;i++) {
          var p = zoneParts(guess);
          var represented = Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);
          guess -= represented - target;
        }
        return guess;
      }
      function nextCycleEnd(){
        var now = Date.now(), p = zoneParts(now);
        var localDay = Math.floor(Date.UTC(p.year,p.month-1,p.day)/86400000);
        var nextEvenBoundary = localDay + (2 - (localDay % 2));
        var d = new Date(nextEvenBoundary*86400000);
        return stockholmLocalMidnightUtc(d.getUTCFullYear(),d.getUTCMonth()+1,d.getUTCDate());
      }
      var end = nextCycleEnd();
      function tick(){
        var now = Date.now();
        if (now >= end) end = nextCycleEnd();
        var diff = Math.max(0,end-now);
        var h = Math.floor(diff/3600000);
        var m = Math.floor((diff%3600000)/60000);
        var s = Math.floor((diff%60000)/1000);
        timer.textContent = String(h).padStart(2,'0')+'T '+String(m).padStart(2,'0')+'M '+String(s).padStart(2,'0')+'S';
      }
      tick();
      window.setInterval(tick,1000);
    }

    var buyNow = box.querySelector('[data-aup-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', async function(){
        var form = box.querySelector('form[data-aup-form]');
        if (!form) return;
        var old = buyNow.textContent;
        buyNow.disabled = true;
        buyNow.textContent = 'Öppnar kassan…';
        try {
          var data = new FormData(form);
          data.delete('on_success');
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          var res = await fetch(root+'cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:data});
          if (!res.ok) throw new Error('cart_add_failed');
          showLoader();
          location.href = root+'checkout';
        } catch(err) {
          buyNow.disabled = false;
          buyNow.textContent = old;
        }
      });
    }
  });
})();
